import { BehaviorSubject } from "rxjs";
import { STATUS } from "./use-loading.model";

export class ApiCallHandler<T> {
   data$ : BehaviorSubject<T|null>;
   status$ : BehaviorSubject<STATUS>;
   error$ = new BehaviorSubject<string | null>(null);
  
    constructor(){
        this.data$ = new BehaviorSubject<T|null>(null);
        this.status$ = new BehaviorSubject<STATUS>(STATUS.pending);
        this.error$ = new BehaviorSubject<string | null>(null);
    };

    public init():void;
    public init(data?:T):void;
    public init(data?:T,status?:STATUS):void;
    public init(data?:T,status?:STATUS,error?:string):void;
    public init(data?:T,status?:STATUS,error?:string):void
    {
      this.data$.next(data??null);
      this.status$.next(status??STATUS.pending);
      this.error$.next(error??null);
    }
  
  }